// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"contentPage_contentWrapper__3zoJP","columns":"contentPage_columns__3x1mD"};